import { Box } from '@mui/material';
import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { getDetailedViewTicketSummary } from 'store/ticket-service/selector';
import { setDetailedViewTicketSummary } from 'store/ticket-service/ticketSlice';

import { NamespacesList } from 'core/enums/common';

import { ReactComponent as Arrow } from 'assets/icons/small-arrow-left.svg';

import { DropdownArrow, DropdownHeader, DropdownTitle } from './styled';
import { UserStoryDropdownProps } from './types';

export const UserStoryDropdown: FC<UserStoryDropdownProps> = ({ userStory, index, isLast }) => {
	const { i18n } = useTranslation(NamespacesList['common']);

	const dispatch = useDispatch();

	const detailedViewTicketSummary = useSelector(getDetailedViewTicketSummary);

	const isDetailedUserStoryViewOpen = useMemo(
		() => userStory?.id === detailedViewTicketSummary?.id,
		[userStory?.id, detailedViewTicketSummary?.id]
	);

	const dropdownHasItems = useMemo(
		() => userStory?.summaryScenarios?.length || userStory?.summaryAcceptanceCriteria?.length,
		[userStory?.summaryScenarios?.length, userStory?.summaryAcceptanceCriteria?.length]
	);

	const handleDropdownClick = () => {
		if (dropdownHasItems) {
			if (!isDetailedUserStoryViewOpen) {
				dispatch(setDetailedViewTicketSummary(userStory));
			} else {
				dispatch(setDetailedViewTicketSummary(null));
			}
		}
	};

	return (
		<Box
			sx={{
				boxSizing: 'border-box',
				width: '100%',
				padding: '16px',
				borderRadius: '8px',
				borderBottom: `${isLast ? '0' : '1px'} solid #E5E7EB`,
				backgroundColor: isDetailedUserStoryViewOpen ? '#ECF3FF' : 'none',
			}}
		>
			{dropdownHasItems !== 0 ? (
				<DropdownHeader
					onClick={handleDropdownClick}
					isStoryOpen={Boolean(isDetailedUserStoryViewOpen)}
				>
					<DropdownTitle>
						{index}. {userStory.data}
					</DropdownTitle>
					<DropdownArrow
						sx={{ transform: `rotate(${i18n.language === 'ar' ? '180deg' : '0deg'})` }}
					>
						<Arrow />
					</DropdownArrow>
				</DropdownHeader>
			) : (
				<DropdownTitle onClick={handleDropdownClick}>
					{index}. {userStory.data}
				</DropdownTitle>
			)}
		</Box>
	);
};
